var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3979 64.398V49.1592",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0174 56.7786L62.398 64.398L54.7786 56.7786",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7164 39H42.0796C39.2742 39 37 41.2742 37 44.0796V69.4776C37 72.283 39.2742 74.5572 42.0796 74.5572H82.7164C85.5218 74.5572 87.796 72.283 87.796 69.4776V44.0796C87.796 41.2742 85.5218 39 82.7164 39Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3979 74.5574V84.7166",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2388 84.7163H72.5572",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs17);
export default __webpack_public_path__ + "static/media/IconFaqs17.1c0e3b764471593c53845d322f657681.svg";
export { ForwardRef as ReactComponent };